import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { FaRegFilePdf } from "react-icons/fa6";
import { FaRegFileImage } from "react-icons/fa";

function JobDetails() {
  const navigate = useNavigate()
  const { state } = useLocation();
  console.log('state: ', state)
  return (
    <div className='container default-padding'>
      <div className="row justify-content-center mb-4">
  <div className="col-md-10 p-4 bg-white rounded-4 shadow-sm border">
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
      <div>
        <h2 className="fw-bold text-primary mb-2">{state?.job?.jobTitle || ''}</h2>
        <div className="d-flex flex-wrap gap-3 fs-6">
          <h6 >
            Vacancies: <strong>{state?.job?.noOfVacancies || 'N/A'}</strong>
          </h6>
          <h6 >
            Experience: <strong>{state?.job?.minExp + ' - ' + state?.job?.maxExp} years</strong>
          </h6>
        </div>
      </div>
      <div>
        <button className="btn btn-gradient-primary px-4 py-2 rounded-pill shadow-sm" onClick={()=>navigate("/career")}>
          Apply Now
        </button>
      </div>
    </div>
  </div>
</div>

      <div className='row justify-content-center mb-2'>
        <div className="col-md-10">
          <div dangerouslySetInnerHTML={{ __html: state?.job?.jobShortDescription || "" }} />
        </div>

      </div>

      <div className='row justify-content-center mb-4'>
        <div className='col-md-10'>
          <div dangerouslySetInnerHTML={{ __html: state?.job?.jobLongDescription || "" }} />
        </div>
      </div>

      {/* {state?.job?.jdFile && state?.job?.jdFile.length > 0} */}
      <div className="row justify-content-center">
        <div className="col-md-10 d-flex flex-wrap gap-3">
          {state?.job?.jdFile?.length > 0 &&
            state.job.jdFile.map((item, index) => (
              <div key={index} className="text-center">
                {item.url.includes(".pdf") ? (
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-danger fs-3 d-block"
                    title={item.title || "View PDF"}
                  >
                    <FaRegFilePdf />
                    <div style={{ fontSize: "12px", wordBreak: "break-word" }}>{item.title}</div>
                  </a>
                ) : (
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary fs-3 d-block"
                    title={item.title || "View Image"}
                  >
                    <FaRegFileImage />

                    <div style={{ fontSize: "12px", wordBreak: "break-word" }}>{item.title}</div>
                  </a>
                )}
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default JobDetails